export default "__VITE_ASSET__8Q5fTBUn__"